import { useQuery } from '@tanstack/react-query';
import ms from 'ms';
import { createContext, useContext } from 'react';

import { getSessionInfo } from 'hb-react/frontoffice/utils/initApp';

const SessionInfoContext = createContext({});

export const SessionInfoProvider = ({ children, type, options }) => {
  const { data = {} } = useQuery({
    queryKey: ['sessionInfo2', type, options],
    queryFn: () => getSessionInfo({ type, options }).then(({ data }) => data),
    staleTime: ms('5m'),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  return (
    <SessionInfoContext.Provider value={data}>
      {children}
    </SessionInfoContext.Provider>
  );
};

export const useSessionInfoContext = () => useContext(SessionInfoContext);

export const withSessionInfoContext = (Component) => (props) => {
  const contextValue = useSessionInfoContext();

  return <Component {...contextValue} {...props} />;
};

export default SessionInfoContext;
